var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row wrapper white-bg page-heading page-title light-bottom-shadow"},[_c('div',{staticClass:"col-sm-12 page-headingRow"},[_c('h2',[_vm._v(_vm._s(_vm.route.meta.name))]),_c('Breadcrumbs'),_vm._t("action-button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }